import { useEffect, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { queryClient } from "../utils/QueryClient";
import { subscribeStomp } from "../utils/stompClient";
import { chatService } from "../services/ChatService";

const PRESENCE_KEY = ["chat", "presence"];

interface PresenceEvent {
  userId: string;
  online: boolean;
}

export const useOnlineUsers = (enabled = true) => {
  const { data } = useQuery({
    queryKey: PRESENCE_KEY,
    queryFn: chatService.getOnlinePresence,
    enabled,
    staleTime: Infinity, // cập nhật qua WS
  });
  return useMemo(() => new Set(data ?? []), [data]);
};

export const usePresenceSocket = (enabled: boolean) => {
  useQuery({ queryKey: PRESENCE_KEY, queryFn: chatService.getOnlinePresence, enabled, staleTime: Infinity });

  useEffect(() => {
    if (!enabled) return;
    const unsubscribe = subscribeStomp<PresenceEvent>("/topic/presence", ({ userId, online }) => {
      queryClient.setQueryData<string[]>(PRESENCE_KEY, (old = []) => {
        const has = old.includes(userId);
        if (online) return has ? old : [...old, userId];
        return has ? old.filter((id) => id !== userId) : old;
      });
    });
    return unsubscribe;
  }, [enabled]);
};
